module.exports = __webpack_public_path__ + "static/media/icon_filters.9090cef7.svg";